export default __webpack_public_path__ + "static/media/Riskometer.1b21f89d.png";